/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_TitleInputs */

const en_guide_json_syntax_errors_title = /** @type {(inputs: Guide_Json_Syntax_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common JSON Syntax Errors and How to Fix Them: PureJSON`)
};

const ko_guide_json_syntax_errors_title = /** @type {(inputs: Guide_Json_Syntax_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`흔한 JSON 구문 오류와 해결 방법: PureJSON`)
};

const ja_guide_json_syntax_errors_title = /** @type {(inputs: Guide_Json_Syntax_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくあるJSON構文エラーとその修正方法: PureJSON`)
};

/**
* | output |
* | --- |
* | "Common JSON Syntax Errors and How to Fix Them: PureJSON" |
*
* @param {Guide_Json_Syntax_Errors_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_title = /** @type {((inputs?: Guide_Json_Syntax_Errors_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_title(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_title(inputs)
	return ja_guide_json_syntax_errors_title(inputs)
});